import './App.css'
import './assets/css/style.css'
import 'react-quill/dist/quill.snow.css'
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'

import { AuthProvider } from './context/AuthContext'
import { ToastContextProvider } from './context/ToastContext'
import AuthorizationRoute from './utils/AuthorizationRoute'
import Login from './pages/Login'
import Home from './pages/Home'
import User from './pages/users/User'

import Faq from './pages/static_content/FAQ'
import AboutUs from './pages/static_content/AboutUs'
import ContactUs from './pages/static_content/ContactUs'
import PrivatePolicy from './pages/static_content/PrivatePolicy'
import TermsAndConditions from './pages/static_content/T&C'
import Profile from 'pages/profile/Profile'
import ForgotPassword from 'pages/auth/ForgotPassword'
import ResetPassword from 'pages/auth/ResetPassword'
import ChangePassword from 'pages/auth/ChangePassword'
import SharedLayout from 'utils/SharedLayout'
import ProtectedRoute from 'utils/ProtectedRoute'
import Notification from 'pages/notification_manager/Notification'
import Blog from 'pages/blog_manager/Blog'
import AddBlog from 'pages/blog_manager/AddBlog'
import EditBlog from 'pages/blog_manager/EditBlog'
import CustomerViewPage from 'pages/users/CustomerViewPage'
import HelpAndSupport from 'pages/help_and_support_manager/helpAndSupport'
import ReportContentView from 'pages/help_and_support_manager/viewReportDetails'
import Category from 'pages/category_and_sub_category_manager/categories'
import SubCategory from 'pages/category_and_sub_category_manager/subCategories'
import ReasonReport from 'pages/reason_report_manager/reasonReports'
import Static from 'pages/static_content/Static'
import ViewBlog from 'pages/blog_manager/ViewBlog'
import UserVerificationManager from 'pages/user_verification_manager/userVerificationManager'
import MultipleChoiceQuestions from 'pages/user_verification_manager/multiple_choice_question/multipleChoiceQuestions'
import SocialConnect from 'pages/user_verification_manager/social_connects/socialConnects'
import District from 'pages/location_manager/districts'
import Upazila from 'pages/location_manager/upazilas'
import Union from 'pages/location_manager/unions'
import RequestManager from 'pages/request_manager/requestManager'
import ListItemView from 'pages/request_manager/sellItemView'
import SellItemView from 'pages/request_manager/sellItemEdit'
import Consultation from 'pages/consultation_manager/consultation'
import ConsultationQueryView from 'pages/consultation_manager/query/consultationQueryView'
import ExpertAddModal from 'pages/consultation_manager/experts/expertAddModal'
import EditExpert from 'pages/consultation_manager/experts/expertEditModal'
import ViewExpert from 'pages/consultation_manager/experts/expertViewModal'
import ViewPostDetails from 'pages/users/posts/View'
import ViewUserSellItems from 'pages/users/soldItems/View'
import ViewUserBuyItem from 'pages/users/buyItems/ViewBuyItems'
import UserSellItemEdit from 'pages/users/newitemSell/sellItemEdit'
import UserSellItemView from 'pages/users/newitemSell/sellItemView'
import UserSellItemAdd from 'pages/request_manager/sellItemAdd'
import NavBarNotification from 'pages/notification_manager/navBarNotifications'
import Tutorials from 'pages/tutorial_manager/tutorials'
import TutorialAdd from 'pages/tutorial_manager/add'
import TutorialEdit from 'pages/tutorial_manager/edit'
import Service from 'pages/service_manager/serviceManager'
import Background from 'pages/background_manager/background'
import Product from 'pages/product_manager/Product'
import Price from 'pages/price_manager/Price'
import Areas from 'pages/area_manager/areas'
import { useEffect } from 'react'
import { setNavigateToLogin } from 'utils/navigateLogin'

function App () {
    const navigate = useNavigate();

    useEffect(() => {
      // setNavigateToLogin(() => () => navigate("/"));
    }, [navigate]);
  return (
    // <BrowserRouter>
      <ToastContextProvider>
        <AuthProvider>
          <Routes>
            <Route element={<SharedLayout />}>
              <Route exact path="/dashboard" element={<Home />} />

              <Route
                exact
                path="/users"
                element={
                  <AuthorizationRoute>
                    <User />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/users/customer-view"
                element={
                  <AuthorizationRoute>
                    <CustomerViewPage />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/faqs"
                element={
                  <AuthorizationRoute>
                    <Faq />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/about-us"
                element={
                  <AuthorizationRoute>
                    <AboutUs />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/contact-us"
                element={
                  <AuthorizationRoute>
                    <ContactUs />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/notifications"
                element={
                  <AuthorizationRoute>
                    <Notification />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/blogs"
                element={
                  <AuthorizationRoute>
                    <Blog />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/blogs/add-blog"
                element={
                  <AuthorizationRoute>
                    <AddBlog />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/blogs/Edit-blog"
                element={
                  <AuthorizationRoute>
                    <EditBlog />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/blogs/View-blog"
                element={
                  <AuthorizationRoute>
                    <ViewBlog />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/terms-and-conditions"
                element={
                  <AuthorizationRoute>
                    <TermsAndConditions />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/static/privacy-policy"
                element={
                  <AuthorizationRoute>
                    <PrivatePolicy />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path="/category"
                element={
                  <AuthorizationRoute>
                    <Category />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/categories/subcategories"
                element={
                  <AuthorizationRoute>
                    <SubCategory />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/change-password"
                element={
                  <ProtectedRoute>
                    <ChangePassword />
                  </ProtectedRoute>
                }
              />

              <Route
                exact
                path="/help-and-support"
                element={
                  <AuthorizationRoute>
                    <HelpAndSupport />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/help-and-support/report-content"
                element={
                  <AuthorizationRoute>
                    <ReportContentView />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/reason-report"
                element={
                  <AuthorizationRoute>
                    <ReasonReport />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/static"
                element={
                  <AuthorizationRoute>
                    <Static />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/user-verification-manager"
                element={
                  <AuthorizationRoute>
                    <UserVerificationManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/user-verification-manager/mcq-list"
                element={
                  <AuthorizationRoute>
                    <MultipleChoiceQuestions />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/user-verification-manager/social-connections"
                element={
                  <AuthorizationRoute>
                    <SocialConnect />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/locations"
                element={
                  <AuthorizationRoute>
                    <District />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="/area"
                element={
                  <AuthorizationRoute>
                    <Areas />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/locations/upazilas"
                element={
                  <AuthorizationRoute>
                    <Upazila />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/locations/unions"
                element={
                  <AuthorizationRoute>
                    <Union />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/marketplace-request-manager"
                element={
                  <AuthorizationRoute>
                    <RequestManager />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/marketplace-request-manager/sell-item"
                element={
                  <AuthorizationRoute>
                    <ListItemView />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/marketplace-request-manager/sell-item-edit"
                element={
                  <AuthorizationRoute>
                    <SellItemView />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/consultation-manager"
                element={
                  <AuthorizationRoute>
                    <Consultation />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/consultation-manager/consultation-query"
                element={
                  <AuthorizationRoute>
                    <ConsultationQueryView />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/consultation-manager/experts/add"
                element={
                  <AuthorizationRoute>
                    <ExpertAddModal />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/consultation-manager/experts/edit"
                element={
                  <AuthorizationRoute>
                    <EditExpert />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/consultation-manager/experts/view"
                element={
                  <AuthorizationRoute>
                    <ViewExpert />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/users/post/view"
                element={
                  <AuthorizationRoute>
                    <ViewPostDetails />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/product"
                element={
                  <AuthorizationRoute>
                    <Product />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/price"
                element={
                  <AuthorizationRoute>
                    <Price />
                  </AuthorizationRoute>
                }
              />

              <Route
                exact
                path="users/sell-item/view"
                element={
                  <AuthorizationRoute>
                    <ViewUserSellItems />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="users/buy-item/view"
                element={
                  <AuthorizationRoute>
                    <ViewUserBuyItem />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/users/user-sell-item"
                element={
                  <AuthorizationRoute>
                    <UserSellItemView />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/users/user-sell-item-edit"
                element={
                  <AuthorizationRoute>
                    <UserSellItemEdit />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/request-manager/user-sell-item-add"
                element={
                  <AuthorizationRoute>
                    <UserSellItemAdd />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/notification"
                element={
                  <AuthorizationRoute>
                    <NavBarNotification />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/tutorials"
                element={
                  <AuthorizationRoute>
                    <Tutorials />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/tutorials/add-tutorial"
                element={
                  <AuthorizationRoute>
                    <TutorialAdd />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/tutorials/edit-tutorial"
                element={
                  <AuthorizationRoute>
                    <TutorialEdit />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/services"
                element={
                  <AuthorizationRoute>
                    <Service />
                  </AuthorizationRoute>
                }
              />
              <Route
                exact
                path="/backgrounds"
                element={
                  <AuthorizationRoute>
                    <Background />
                  </AuthorizationRoute>
                }
              />
            </Route>

            <Route exact path="/" element={<Login />} />
            <Route exact path="/login" element={<Login />} />

            <Route exact path="/forgot-password" element={<ForgotPassword />} />

            <Route
              exact
              path="/reset-password/:resetToken"
              element={<ResetPassword />}
            />
          </Routes>
        </AuthProvider>
      </ToastContextProvider>
    // </BrowserRouter>
  );
}

export default App
